import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import DistanceUnitForm from '../Forms/DistanceUnitForm';

const AddEditDistanceUnitModal = ({
	dataDistanceUnit,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Unidad de Distancia
			</ModalHeader>

			<DistanceUnitForm
				dataDistanceUnit={dataDistanceUnit}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditDistanceUnitModal;
